export default __webpack_public_path__ + "static/4-14523067b916db1dcc112983d9e94436.png";